var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"app-icon",class:`app-icon--${_vm.size}`,style:({ background: _vm.gradient }),attrs:{"aria-hidden":"true"}},[_c('i',{class:_vm.icon})])
}
var staticRenderFns = []

export { render, staticRenderFns }